import Vue from 'vue';
import moment from 'moment';

export function dateFilter(dateStr: string | Date | undefined, format: string | undefined): string {
  if (!dateStr) {
    return '';
  }

  return moment(dateStr).format(format);
}

Vue.filter('date', dateFilter);
